import {parseQuery} from "../../utils/queryParser";
import {computed, observable} from "mobx";

export class GettingToPageQueryParams {
    @observable private parsed:boolean = false;

    @observable facilityLocationId?:string;
    @observable buildingId?:string;
    @observable destinationId?: string; 
    lang?:string;

    public parse(query:string) {
        const params = parseQuery(query);

        Object.keys(params).forEach(k => this[k] = params[k]);

        this.parsed = true;
    }

    @computed
    public get isValid():boolean{
        if(!this.parsed)
            return true;

        return !!(this.facilityLocationId || this.destinationId) && !!this.buildingId;
    }
}

export interface IGettingToPageLoadDataParams{
    facilityLocationId?:string;
    buildingId?:string;
    destinationId?: string;
}
